import React from 'react'
import './News.css'

const News = () => {
  return (
    <div className='News'>
      <div className="News_title">
        News and Updates
      </div>
      <div className='sectionOne'>
          <div className='card'>శ్రీ మందేశ్వర స్వామివారి ఆలయంలో స్వయంగారాలేని భక్తులు చెల్లించు రుసుము
          ద్వారా ఆలయ అర్చకులచే జరుగు పరోక్ష తైలాభిషేకములు భక్తుల సౌకర్యార్థం
          ప్రతి శనివారం ఉదయం 12.00 గంటలకు (శనిత్రయోదసి రోజు మాత్రం పూజ జరుగు
          సమయం మార్చబడును) శ్రీ స్వామివారి Youtube ఛానెల్
          https://youtube.com/c/SriMandeswaraMandapalli ద్వారా ప్రత్యక్షప్రసారం
          గా జరిపించబడును కావున భక్తులు ఈ ఛానెల్ ని subscribe చేసుకుని తమ తరుపున
          జరుగుపరోక్ష తైలాభిషేకం కనులారా వీక్షించి శ్రీ స్వామివారి అనుగ్రహానికి
          పాత్రులు కాగలరని తెలియచేయడమైనది.🙏</div>
          <div className='card'>ANNADANAM has started by the Sri Mandeswara Swamy vari Devasthanam on
          SATURDAYS for devotees coming from various places</div>
      </div>
    </div>
  )
}

export default News